<template>
  <info-dialog v-model="modelValue" title="Critérios diagnósticos de Hanifin & Rajka">
    <p>
      Para o diagnóstico de dermatite atópica, o paciente deve apresentar ≥ 3 critérios maiores ou ≥ 3 critérios
      menores.
    </p>
    <img src="/assets/attendance-form/hanifin-rajka.png" alt="" />
    <v-row>
      <v-col cols="12">
        <span class="reference"> Fonte: Adaptado de Hanifin et al. (1980). </span>
      </v-col>
    </v-row>
  </info-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import InfoDialog from '@/components/NewAttendanceForm/FormNodes/InfoDialogs/InfoDialog.vue'

export default {
  name: 'HanifinAndRajkaDialog',
  components: { InfoDialog },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scopde>
.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}
</style>
